import React from "react";
import S from "./Style";

export default function Spiner({ size, color,style }) {
  return <S.Spiner wh={size} color={color} style={style}></S.Spiner>;
}
